import React, { useState, useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Cover } from "../components";

gsap.registerPlugin(ScrollTrigger);

const path = process.env.PUBLIC_URL

const bgData = [0, 1, 2, 3]

const articleData = [
  { bg: '0', dialog: [ { text: "We’ve been chatting for two months, right? Don’t you want to meet me? How about seeing a movie together?", class: "p__0 bubble left"}, { text: "Ok. I’ll see you Friday morning at 10.", class: "p__1 bubble right"} ] },
  { bg: '1', dialog: [ { text: "Hey", class: "p__2 bubble left"}, { text: "Hey!", class: "p__3 bubble right"} ] },
  { bg: '2' },
  { bg: '3' },
  { bg: '4' },
  { bg: '5', dialog: [ { text: "All my HIV reagent tests are used up. You…", class: "p__4 bubble right"}, { text: "“I just got tested and am very healthy, and I have a condom.", class: "p__5 bubble left"} ]},
  { bg: '5', dialog: [ { text: "When did you take the condom off?!", class: "p__4 bubble right"}, { text: "Sorry, I just couldn’t hold back…", class: "p__5 bubble left"}, { text: "Don’t go. We’re going to the hospital to get tested right now.", class: "p__51 bubble right"} ], time: ['1 2 : 3 0', '0 hours since exposure']},
  { bg: '6', dialog: [ { text: "I took him to the Haikou Center For Disease Control and Prevention to take two tests.", class: "p__9"} ], time: ['1 4 : 0 0', '1.5 hours since exposure']},
  { bg: '7', dialog: [ { text: "I immediately looked for post-exposure prophylaxis at the disease control center.", class: "p__9"}, { text: "I’m sorry. Disease control drugs can only be used for post-exposure prevention for confirmed patients living with HIV and occupationally exposed people.", class: "p__6 bubble left"} ]},
  { bg: '8', dialog: [ { text: "I have to take the prevention medicine within 72 hours of exposure to prevent an HIV infection.", class: "p__9"}, { text: "You didn’t take your purchase after you paid! Boy, you haven’t taken your water yet!", class: "p__8 bubble left"} ]},
  { bg: '10', dialog: [ { text: "Do you know where to buy prevention medicine?", class: "p__10 bubble left"}, { text: "Do you know where to buy prevention medicine?", class: "p__11 bubble left"}, { text: "Do you know where to buy prevention medicine?", class: "p__12 bubble left"}, { text: "Hi, do you prescribe HIV post-exposure prophylaxis here?", class: "p__13 bubble right"}, { text: "HIV post-exposure drugs? We don’t have them here.", class: "p__14 bubble left"} ]},
  { bg: '9', dialog: [ { text: "In your case, you can only tell the doctor you have Hepatitis B and are eager to buy antiviral drugs. First, buy lamivudine and tenofovir. There is another drug you can only buy in Guangzhou. Take all three to block it. Go quick.", class: "p__15 bubble right"} ], time: ['1 6 : 3 0', '4 hours since exposure']},
  { bg: '12', dialog: [ { text: "I don’t know when the plane will take off in this weather.", class: "p__9"} ], time: ['2 0 : 0 0', '7.5 hours since exposure']},
  { bg: '13_b', time: ['0 0 : 2 0', '11.8 hours since exposure', 'The next day'] },
  { bg: '14', dialog: [ { text: "After 16 hours, I finally got dolutegravir (the medicine only sold in Guangzhou) and started a nearly month-long prevention treatment.", class: "p__9"} ], time: ['0 4 : 3 0', '16 hours since exposure', 'The next day']},
]

const Slider = (props) => {
  const container = React.createRef();
  const slick = React.createRef();
  const [progress, setProgress] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(-2);
  const [bgIndex, setBgIndex] = useState(0);

  useEffect(() => {
		let sections = gsap.utils.toArray(".panel");
		gsap.timeline({
			scrollTrigger: {
				trigger: container.current,
				// pin: true,
				scrub: 1,
				start: "top top",
        end: "bottom bottom",
        onUpdate: self => {
          let index_bg = Math.round(self.progress * (sections.length - 1) * 15)
          let index = Math.round(self.progress * (articleData.length + 2 - 1)) - 2
          setProgress(self.progress)
          setCurrentIndex(index)
          setBgIndex(index_bg)
        },
        invalidateOnRefresh: true
			}
    });
  }, []);

  return (
    <div className="container" ref={container}>
      {bgData.map((number, index) =>
        <div
          key={'bg' + index}
          className={"bg" + (bgIndex % 4 === index ? " active" : "")}
          style={{ backgroundImage: 'url(' + path + '/images/00' + index + '.jpg)' }}
        />
      )}
      <Cover />
      <div className={"progress-bar" + ((currentIndex >= 0 && progress < 1) ? " active" : " ")}>
        <div className="passed-bar" style={{width: (progress - 1/16)* 16 / 15 * 100 + '%'}} />
      </div>
      <div
        className="panel__wrapper"
      >
        <div className={"panel" + (currentIndex === -1 ? " active" : " ")}>
          <div className="panel__section">
            <div className="panel__intro">Why is HIV getting closer and closer to us? We start with Xu Peng’s story…</div>
          </div>
        </div>
        {articleData.map((article, index) =>
          <div
            key={'panel' + index}
            className={"panel" + (currentIndex === index ? " active" : " ")}
          >
            <div className="panel__bg" style={{ backgroundImage: 'url(' + path + '/images/image' + article.bg + '.png)' }}></div>
            <div className="panel__section">
              {article.dialog && article.dialog.map((log, index) =>
                <div className={log.class}>{log.text}</div>
              )}
              { article.time && (
                <div className="panel__time"><span>{article.time[0]}</span> {article.time[2]} -- {article.time[1]}</div>
              )}
            </div>
          </div>
        )}
        <button className="skipButton" onClick={() => props.scrollToElement({ value: 1, label: 'How do preventive medicines work?' })}>Skip</button>
      </div>
    </div>
  )
}

export default Slider;